import { useContext } from 'react';

import { HierarchyRFMConfigContext } from '../context/HierarchyRFMConfig';

const useHierarchyRFMConfig = () => useContext(HierarchyRFMConfigContext);

export default useHierarchyRFMConfig;
